/* Showrooms - This line cannot be edited or removed */
export const GET_SHOWROOMS = "GET_SHOWROOMS"
export const GET_SHOWROOMS_SUCCESS = "GET_SHOWROOMS_SUCCESS"
export const GET_SHOWROOMS_FAIL = "GET_SHOWROOMS_FAIL"

/* Showrooms DETAILS */
export const GET_SHOWROOM_DETAILS = "GET_SHOWROOM_DETAILS"
export const GET_SHOWROOM_DETAILS_SUCCESS = "GET_SHOWROOM_DETAILS_SUCCESS"
export const GET_SHOWROOM_DETAILS_FAIL = "GET_SHOWROOM_DETAILS_FAIL"

/* CREATE Showrooms */
export const CREATE_SHOWROOM = "CREATE_SHOWROOM"
export const CREATE_SHOWROOM_SUCCESS = "CREATE_SHOWROOM_SUCCESS"
export const CREATE_SHOWROOM_FAIL = "CREATE_SHOWROOM_FAIL"

/* Edit Showrooms */
export const UPDATE_SHOWROOM = "UPDATE_SHOWROOM"
export const UPDATE_SHOWROOM_SUCCESS = "UPDATE_SHOWROOM_SUCCESS"
export const UPDATE_SHOWROOM_FAIL = "UPDATE_SHOWROOM_FAIL"

/* Delete Showrooms */
export const DELETE_SHOWROOM = "DELETE_SHOWROOM"
export const DELETE_SHOWROOM_SUCCESS = "DELETE_SHOWROOM_SUCCESS"
export const DELETE_SHOWROOM_FAIL = "DELETE_SHOWROOM_FAIL"

